/**
 * Created by Ramon Wenger on 04.07.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */
import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {AdminMessage} from "./admin-message";
import {DomSanitizer} from "@angular/platform-browser";
import * as reducers from "../reducers";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ModalComponent} from "../modal/modal";

@Component({
  selector: 'hc-admin-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <hc-modal
      [modalSizeLarge]="true"
      (close)="cancelAction()">
      <h4 header class="modal-title" translate>Das digitale Klassenbuch schliesst sich</h4>
      <div body>
        <p [innerHTML]="message() | nl2br"></p>
        <p translate><a href="https://www.helloclass.ch" target="_blank">Erfahre mehr</a></p>
        <div class="vertical-margin modal-body__actions">
          <button
            class="btn btn--full-width btn-primary btn--innershadowy"
            aria-label="Confirm"
            (click)="confirmAction()"
            data-cy="modalConfirmButton" translate>Als gelesen markieren
          </button>
          <ng-content></ng-content>

        </div>
      </div>
    </hc-modal>
  `

})
export class AdminMessageComponent {
  @Input() adminMessage: AdminMessage;
  @Input() language: string;
  @Output() hasRead = new EventEmitter<number>();
  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @ViewChild(ModalComponent, {static: false}) public modal: ModalComponent;

  constructor(private sanitizer: DomSanitizer,
              private elRef: ElementRef,
              private router: Router,
              private store: Store<reducers.AppState>) {

    console.warn(this.adminMessage);
  }

  ngAfterViewInit() {
    // handle modal updates
    this.show();
  }

  read(id: number) {
    this.hasRead.emit(id);
  }

  message() {
    let message = '';
    switch (this.language) {
      case 'fr':
        message = this.adminMessage.message_french;
      case 'it':
        message = this.adminMessage.message_italian;
      case 'de':
      default:
        message = this.adminMessage.message_german;
    }

    // message = message.replace('${ID}', this.adminMessage.id.toString());
    // setTimeout(() => {
    //   // quick and dirty accept
    //   this.elRef.nativeElement.querySelector('[data-accept="true"]').addEventListener('click', this.accept.bind(this));
    // })
    return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  accept() {
    this.read(this.adminMessage.id);
  }

  show(): void {
    this.modal.show();
  }

  hide(): void {
    this.modal.hide();
  }


  public confirmAction(): void {
    this.accept()
    this.confirm.emit();
  }

  public cancelAction(): void {
    this.modal.hide();
  }
}
